import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import SpeedOutlinedIcon from "@mui/icons-material/SpeedOutlined";
import classNames from "classnames";
import { Trans } from "../utils/i18n";

export function SelfGuideCard({ image, name, time, complexity, targetUser }) {
    return (
        <div
            className={classNames(
                "flex flex-1 flex-col shadow-md overflow-hidden rounded-md no-underline text-black"
            )}
        >
            {image && (
                <img
                    src={image}
                    className={classNames("object-cover h-40 w-full")}
                />
            )}

            <div className="p-4 space-y-4">
                <div className="font-semibold text-xl">{name}</div>

                <ul className="space-y-2 m-0 p-0">
                    {time && (
                        <li className="flex items-center gap-2">
                            <AccessTimeOutlinedIcon />
                            <span>{time}</span>
                        </li>
                    )}
                    {complexity && (
                        <li className="flex items-center gap-2">
                            <SpeedOutlinedIcon />
                            <span>
                                {complexity === "low" ? (
                                    <Trans i18nKey="selfRepair.complexity.low">
                                        Low
                                    </Trans>
                                ) : complexity === "medium" ? (
                                    <Trans i18nKey="selfRepair.complexity.medium">
                                        Medium
                                    </Trans>
                                ) : complexity === "high" ? (
                                    <Trans i18nKey="selfRepair.complexity.high">
                                        High
                                    </Trans>
                                ) : null}
                            </span>
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
}
